export default "/_next/static/media/landing-hero-mob.9c20d4df48113cbc94c4e9d4d0b80ccc.webm";